/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_Loading_YoutubeInputs */



/**
* | output |
* | --- |
* | "Loading YouTube Video..." |
*
* @param {Load_Project_File_Status_Loading_YoutubeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_loading_youtube = /** @type {((inputs?: Load_Project_File_Status_Loading_YoutubeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_Loading_YoutubeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement de la video YouTube...")
	if (locale === "de") return /** @type {LocalizedString} */ ("YouTube-Video wird geladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento video di YouTube...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка видео с YouTube...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando vídeo de YouTube...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载 YouTube 视频...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("YouTube ビデオを読み込んでいます...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यूट्यूब वीडियो लोड हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando vídeo do YouTube...")
	return /** @type {LocalizedString} */ ("Loading YouTube Video...")
});